import { Statistic } from '../../../workers/sortAndFilter/statistics/statistics.worker';
import { Command, ProductTypeData } from '../interfaces';
import { FilterCommand } from './FilterCommand';

/**
 * Filter based on the product type. I.e. treatment product type is "regular", "prescriptionOnly", "pharmacy".
 *
 * If the key === true then only return PRODUCT + PMED.
 * If the key === false then return all products.
 *
 * A data element can have the following values for it's 'type'
 * "regular" === PRODUCT
 * "prescriptionOnly" === ODONLY
 * "pharmacy" === PMED
 * @param data a treatment
 * @returns ProductTypeData[]
 */
export const productTypeFilterStatistics = <T extends ProductTypeData>(data: T[], key: boolean) => {
    let result: ProductTypeData[] = [];
    if (key) {
        result = data.filter((element) => element.type === 'regular' || element.type === 'pharmacy');
    }
    if (!key) {
        result = [...data];
    }
    return result;
};

export class ProductTypeFilterStatisticsCommand extends FilterCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    execute(data: ProductTypeData[]) {
        let items = null;
        const statistics: Statistic[] = [];
        [true, false].forEach((value) => {
            items = productTypeFilterStatistics(data, value);
            const statistic = {
                type: this.type,
                key: value,
                statistics: {
                    value: items.length,
                },
            };
            statistics.push(statistic);
        });
        return statistics;
    }
}
